import { CheckCircleOutlined } from '@ant-design/icons';
import useUserStore from '@lcsc-ui/store/user';
import { Modal, Button } from 'antd';

export default function GoBuyDialog({ isShowFavoriteModel, setIsShowFavoriteModel, handleOk }) {
  const projectConfigVO = useUserStore((state) => state.projectConfigVO);
  return (
    <Modal
      width="500px"
      title="我的收藏"
      open={isShowFavoriteModel}
      onCancel={() => setIsShowFavoriteModel(false)}
      centered
      footer={[
        <Button key="submit" type="primary" onClick={handleOk}>
          确定
        </Button>,
      ]}
    >
      <div className="text-[14px] mt-[20px]" data-spm="xsc">
        <div className="flex">
          <CheckCircleOutlined className="text-[#71c000] text-[50px] mr-[20px]" />
          <div>
            <p className="text-[#71c000] bold text-[16px]">该商品已经成功添加到了您的收藏夹</p>
            <a
              className="text-[#0093e6] mt-[10px]"
              href={`${projectConfigVO.lcscMemberUrl}/member/favorite.html`}
              data-spm="sc"
            >
              查看我的收藏夹
            </a>
          </div>
        </div>
      </div>
    </Modal>
  );
}
